import { NEW_UPLOADS, updateBuyerOrderReference } from "@rpforms/shared";
import { openEditor } from "@rpforms/shared/build/actions/editor";
import React, { useState } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Dispatch } from "redux";
import styled from "styled-components";
import { ModalBuyerOrderReference } from "../modal/ModalBuyerOrderReference";
import { ModalMailText, supportsMailText } from "../modal/ModalMailText";

const StyledDropDown = styled.div`
    margin-left: 8px;

    #dropdown-basic::after {
        display: none;
    }
`;

const uploadModal = (entryId: number, dispatch: Dispatch<any>) => {
    dispatch(
        openEditor({
            endpoint: `form_entries/${entryId}/upload`,
            endpointCompany: false,
            new: true,
            type: NEW_UPLOADS,
        })
    );
};

export default function EntryRowOptions({
    entry,
    migrate,
    previousPage,
    setShow,
    deleteEntry,
    template,
    regenerate,
    createEditTaskClick,
}) {
    const { regeneratingPDF } = useSelector<any, any>((state) => state.formEntries);
    const dispatch = useDispatch();
    const isInvoice = entry?.form?.name === "000_Rechnung";
    const hasMailText = supportsMailText(entry);

    const [showBuyerOrderModal, setShowBuyerOrderModal] = useState(false);
    const [showMailTextModal, setShowMailTextModal] = useState(false);

    const handleSaveBuyerOrderReference = async (payload: any) => {
        try {
            await dispatch(updateBuyerOrderReference(entry.id, payload));
            entry.buyer_order_reference_number = payload.buyer_order_reference_number;
            entry.zugferd_bt_fields = payload.zugferd_bt_fields;
            toast.success("ZUGFeRD-Felder erfolgreich aktualisiert");
            setShowBuyerOrderModal(false);
        } catch (error) {
            toast.error("Fehler beim Aktualisieren der ZUGFeRD-Felder");
        }
    };

    return (
        <StyledDropDown>
            <Dropdown>
                <Dropdown.Toggle
                    id="dropdown-basic"
                    as="i"
                    style={{ cursor: "pointer", margin: "0 10px" }}
                >
                    <i className="fa fa-ellipsis-h" style={{ fontSize: "24px" }}></i>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item
                        as={Link}
                        disabled={entry.cancellation}
                        to={"/entries/editor/entry-edit-" + entry.id + "?page=" + previousPage}
                    >
                        <i className="fa fa-pencil"></i>
                        {` Bearbeiten / Bewegen`}
                    </Dropdown.Item>

                    <Dropdown.Item onClick={migrate}>
                        <i className="fa fa-exchange" />
                        {` Verwenden`}
                    </Dropdown.Item>

                    <Dropdown.Item onClick={template}>
                        <i className="fa fa-pencil-square" />
                        {` als Vorlage nutzen`}
                    </Dropdown.Item>

                    {entry.pdf && (
                        <Dropdown.Item onClick={() => uploadModal(entry.id, dispatch)}>
                            <i className="fa fa-arrow-circle-up" />
                            {` Neue Datei hochladen`}
                        </Dropdown.Item>
                    )}

                    {regeneratingPDF ? (
                        <Dropdown.Item onClick={() => void 0}>
                            <Spinner animation={"border"} size={"sm"} /> Ein PDF wird noch
                            generiert...
                        </Dropdown.Item>
                    ) : (
                        <Dropdown.Item onClick={regenerate}>
                            <i className="fa fa-file-pdf-o" />
                            {isInvoice ? ` E-Rechnung neu generieren` : ` PDF neu generieren`}
                        </Dropdown.Item>
                    )}

                    {isInvoice && (
                        <Dropdown.Item onClick={() => setShowBuyerOrderModal(true)}>
                            <i className="fa fa-hashtag" />
                            {` ZUGFeRD Referenzen`}
                        </Dropdown.Item>
                    )}
                    {hasMailText && (
                        <Dropdown.Item onClick={() => setShowMailTextModal(true)}>
                            <i className="fa fa-envelope-o" />
                            {` KI-Mailtext`}
                        </Dropdown.Item>
                    )}
                    <Dropdown.Item onClick={() => deleteEntry()} disabled={entry.cancellation}>
                        <i className="fa fa-trash" />
                        {` Löschen`}
                    </Dropdown.Item>
                    {entry.device_name !== "-" && (
                        <Dropdown.Item onClick={() => createEditTaskClick(entry.id, entry)}>
                            <i className="fa fa-edit" />
                            {` Nachbearbeitung erstellen`}
                        </Dropdown.Item>
                    )}
                </Dropdown.Menu>
            </Dropdown>

            <ModalBuyerOrderReference
                entry={entry}
                show={showBuyerOrderModal}
                onSave={handleSaveBuyerOrderReference}
                onClose={() => setShowBuyerOrderModal(false)}
            />
            {hasMailText && (
                <ModalMailText
                    entry={entry}
                    show={showMailTextModal}
                    onClose={() => setShowMailTextModal(false)}
                />
            )}
        </StyledDropDown>
    );
}
